export default {
  // common
  ok: 'OK',
  cancel: 'Cancelar',
  send: 'Enviar',
  // time
  timeJustNow: 'Agora mesmo',
  timeMinutesAgo: 'há {n} min',
  timeHoursAgo: 'há {n} h',
  timeYesterday: 'Ontem',
  // chat toolbar titles
  chatEmotion: 'Emoji',
  chatSendImage: 'Enviar imagem',
  chatSendFile: 'Enviar ficheiro',
  chatReceipt: 'Mensagem com confirmação',
  chatSendVoice: 'Enviar voz',
  chatGroupInfo: 'Info do grupo',
  // chat area
  chatSomeoneAtMe: 'Alguém mencionou-me',
  chatNewMessages: '{n} novas mensagens',
  chatBackToBottom: 'Voltar ao fundo',
  chatReceiptPrefix: '[Confirmação] ',
  // message actions / tips
  chatNoMoreMessages: 'Não há mais mensagens',
  chatDeleteConfirm: 'Eliminar esta mensagem?',
  chatDeleteTitle: 'Eliminar mensagem',
  chatRecallConfirm: 'Retirar esta mensagem?',
  chatRecallTitle: 'Retirar mensagem',
  chatRecalled: 'Mensagem retirada',
  chatLocateFail: 'Não foi possível localizar a mensagem original',
  chatResendUnsupported: 'Esta mensagem não suporta reenvio automático. Reenvie manualmente.',
  // input disabled tips
  chatGroupDissolved: 'O grupo foi dissolvido',
  chatGroupQuit: 'Já não pertence a este grupo',
  chatGroupBanned: 'O grupo foi silenciado',
  chatUserBanned: 'Esta conta foi banida',
  chatBanReason: ', motivo: ',
  // message status / readed
  msgReaded: 'Lida',
  msgUnread: 'Não lida',
  msgAllReaded: 'Todas lidas',
  msgSomeReaded: 'Lida por {n}',
  msgSending: 'A enviar',
  msgSendFail: 'Falha ao enviar',
  msgRecall: 'Chamar novamente',
  msgMenuDelete: 'Eliminar',
  msgMenuRecall: 'Retirar',
  // voice record
  recordTitle: 'Gravação de voz',
  recordDuration: 'Duração',
  recordStart: 'Iniciar',
  recordPause: 'Pausar',
  recordResume: 'Retomar',
  recordStop: 'Parar',
  recordPlay: 'Reproduzir',
  recordStopPlay: 'Parar reprodução',
  recordRestart: 'Regravar',
  recordSend: 'Enviar agora',
  recordStateReady: 'Não iniciado',
  recordStateRunning: 'A gravar...',
  recordStatePaused: 'Gravação em pausa',
  recordStateStopped: 'Gravação parada',
  msgReadedTab: 'Lida ({n})',
  msgUnreadTab: 'Não lida ({n})',
  // language
  langLabel: 'Idioma',
  langZh: '中文',
  langEn: 'English'
}
